import { Component, h, Host, Prop } from '@stencil/core';

@Component({
  tag: 'ugc-review-translated-from',
  shadow: false,
})
export class UgcReviewTranslatedFrom {
  @Prop() translatedText: string = '';

  render() {
    if (!this.translatedText) return null;
    return <Host class="fs-14 c-666 translate-text">{this.translatedText}</Host>;
  }
}
